import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { colors, palette, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamily } from "@clockwise/web-commons/src/styles/type.styles";

const buttonContainer: CSSProperties = {
  position: "absolute",
  bottom: 0,
  display: "flex",
  flexDirection: "row",
  zIndex: 15,

  "&.left": {
    left: 0,
  },

  "&.right": {
    right: 0,
  },
};

const button: CSSProperties = {
  color: greys.white,
  padding: 28,
  borderRadius: 0,
  boxShadow: "0px -1px 5px rgba(0, 0, 0, 0.1)",

  "& .label": {
    fontFamily,
    textTransform: "uppercase",
    padding: "0 20px",
    fontSize: "18px",
    lineHeight: "21px",
  },

  "&:disabled:not(.loading)": {
    backgroundColor: palette.cloudyBlue,
    color: greys.white,

    "&:hover": {
      backgroundColor: palette.cloudyBlue,
      color: greys.white,
    },
  },
};

const backButton: CSSProperties = {
  ...button,

  backgroundColor: greys.white,
  color: greys.slate,
  borderTopRightRadius: 4,

  "&:hover": {
    backgroundColor: greys.palePaleGrey,
  },
  "&:disabled.loading": {
    backgroundColor: greys.white,
    color: greys.slate,

    "&:hover": {
      backgroundColor: greys.palePaleGrey,
    },
  },
};

const forwardButton: CSSProperties = {
  ...button,

  backgroundColor: colors.green.standard,
  borderTopLeftRadius: 4,

  "&:hover": {
    backgroundColor: colors.green.lighter,
  },

  "&:disabled.loading": {
    backgroundColor: colors.green.standard,
    color: greys.white,

    "&:hover": {
      backgroundColor: colors.green.lighter,
    },
  },

  "&.skip-enabled": {
    borderTopLeftRadius: 0,
  },
};

const skipButton: CSSProperties = {
  ...button,

  backgroundColor: greys.white,
  color: greys.slate,
  borderTopLeftRadius: 4,

  "&:hover": {
    backgroundColor: greys.palePaleGrey,
  },
  "&:disabled.loading": {
    backgroundColor: greys.white,
    color: greys.slate,

    "&:hover": {
      backgroundColor: greys.palePaleGrey,
    },
  },
};

export const styles = {
  buttonContainer,
  backButton,
  forwardButton,
  skipButton,
};
